<template>
<div>
	<div class="container container--small pdt-50 ">
		<div class="t-headline10 font-5 mgb-8 pdl-24 pdr-24">{{$t('364')}}</div>
		<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('392')}}<br>
			{{$t('426')}}
		</div>
		<form @submit.prevent="" novalidate>
		<div class="mgt-40 pdl-24 pdr-24 position-relative">
			<label
				class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
			data-mdc-auto-init="MDCTextField"
			:class="submitState && passwordInvalidCheck ? 'mdc-text-field--invalid' : ''"
					id="passwordEl">
				<span class="mdc-notched-outline">
					<span class="mdc-notched-outline__leading"></span>
					<span class="mdc-notched-outline__notch">
						<span class="mdc-floating-label font-r t-body6" id="my-label-id">{{$t('393')}}</span>
					</span>
					<span class="mdc-notched-outline__trailing"></span>
				</span>
				<input class="mdc-text-field__input font-r t-body6" type="password"
						aria-labelledby="my-label-id"
						id="password"
						name="password"
						v-model="password"
						v-validate="'required|min:8|verify_password'"
						ref="password">
				<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button"
								:class="validIcon === 'check' ? 'check_show' : ''"
								>{{validIcon}}</i>
			</label>
			<div class="mdc-text-field-helper-line d-block">
				<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r "
						id="my-helper-id" aria-hidden="true"
						:class="submitState && passwordInvalidCheck ? 't-color-textfieldError' : ''">
								{{$t('394')}}
				</div>
			</div>
		</div>
		<div class="mgt-30 pdl-24 pdr-24">
			<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8" @click="changePassword" @keypress="changePassword" tabindex="0">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('395')}}</span>
			</button>
			<button class="mdc-button t-color-secondaryBtnText" @click="cancelFindPw()" @keypress="cancelFindPw()" tabindex="0">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('396')}}</span>
			</button>
		</div>
		</form>
</div>
	</div>
</template>

<script>
/**
 * 비밀번호 재설정 Step4 컴포넌트 (reset password Step4 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import {mapState, mapMutations} from 'vuex'
import {findPwMixin} from '@/mixins/findPw.js'

export default {
	data() {
		return {
			password: '',
			passwordTextField: null,
			submitState: false,
			validIcon: 'report_problem'
		}
	},

	mixins: [findPwMixin],

	computed: {
		...mapState('findPw',{
			findPw : state => state,
		}),

		passwordInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('password')) {
					returnValue = true
					this.validIcon = 'report_problem'
				}else {
					returnValue = false
					this.validIcon = 'check'
				}
			}

			this.passwordTextField.valid === !returnValue ? '' : this.passwordTextField.valid = !returnValue
			return returnValue
		}
	},

	mounted() {
		// 토큰값이 없을 경우 Step1로 이동(If there is no token value, go to Step1)
		if (!this.findPw.step3.token) {
      this.pathName ? this.$moveLogin() : this.$moveBrandSelect();
		}

		this.setMaterialUi()
		this.$refs.password.focus()
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('findPw', ['SET_PASSWORD']),

		setMaterialUi() {
			window.mdc.autoInit();
			const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
			this.passwordTextField = new MDCTextField(document.querySelector('#passwordEl'))
			this.passwordTextField.useNativeValidation = false

			const buttonRipple = [].map.call(document.querySelectorAll(selector), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		// 패스워드 유효성 체크 및 다음화면으로 이동(validation password and move next screen)
		changePassword() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					this.SET_PASSWORD(this.password)
					this.$router.push({
						name: 'FindPwStep5',
					})
				}else {
					this.$refs.password.focus()
				}
			})
		}

	},
}
</script>
<style scoped>
.check_show{
	display: block !important;;
}
</style>
